export const segments: any = [
  {
    segment: 'details',
    name: 'details',
    title: 'Asset details',
    circleIcon: false,
    active: false,
  },
  {
    segment: 'assignments',
    name: 'assignments',
    title: 'Assignments',
    circleIcon: false,
    active: false,
  },
];
